import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const AnonymousRoute = ({ children }) => {
  const isAuthenticated = useSelector(({ auth }) => auth.isAuthenticated);
  return isAuthenticated ? <Navigate to="/homes" replace /> : children;
};

export default AnonymousRoute;
